import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';
import CommonOlList from '../../../common-components/common-ol-list';

const CommonOlListObj = {
    colorNumber: '#90134e',
    list: [
        'Заявка на&nbsp;финансирование',
        'Консультационные услуги',
        'Заявка на&nbsp;ТУ',
        'Интегратор мер поддержки инверсторов',
        'Заявка на&nbsp;резидентство и&nbsp;получение бизнес-плана',
        'Заявка на&nbsp;поиск инвестора',
        'Торговая площадка',
    ],
};

const Task = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper className="krdv-task" smallPaddings={true}>
                <CommonTitle>Задача</CommonTitle>
                <div className="krdv-task__wrapper">
                    <CommonUsualText className="krdv-task__info">
                        Нам нужно было разработать инновационные сервисы для системы личных
                        кабинетов представителей юридических лиц, которые не&nbsp;имеют аналогов
                        в&nbsp;России:
                    </CommonUsualText>
                    <div className="krdv__list">
                        <CommonOlList CommonOlList={CommonOlListObj} />
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Task;
